import type { Channel } from '@entities/channel'
import { useChannels } from '@entities/channel'
import { CopyButton } from '@shared/ui/copy-button/copy-button'
import type { TableProps } from 'antd'
import { Checkbox, Col, Row, Space, Table, Typography } from 'antd'
import { useMemo } from 'react'

const { Text } = Typography

export const AdvertisingPlatforms = () => {
    const {
        channels,
        actions: { editChannel }
    } = useChannels()

    const columns: TableProps<Channel>['columns'] = useMemo(
        () => [
            {
                title: 'Название интернет ресурса',
                dataIndex: 'name',
                key: 'name',
                render: (_, record) => (
                    <Space style={{ width: '100%', justifyContent: 'space-between' }}>
                        <Text>{record.name}</Text>
                        <CopyButton textToCopy={record.name} />
                    </Space>
                )
            },
            {
                title: 'Отображать для партнеров',
                dataIndex: 'visible',
                key: 'visible',
                align: 'center',
                render: (_, record) => (
                    <Checkbox
                        checked={record.visibleForPartners}
                        onChange={(e) => editChannel({ id: record.id, data: { visibleForPartners: e.target.checked } })}
                    />
                )
            }
        ],
        [editChannel]
    )

    return (
        <Row
            style={{
                maxHeight: 'calc(100vh - 540px)',
                overflow: 'auto'
            }}
        >
            <Col span={7}>
                <Table<Channel> columns={columns} dataSource={channels} pagination={false} />
            </Col>
        </Row>
    )
}
